import { Link } from "react-router-dom";
import { FiFilter } from "react-icons/fi";
import { useEffect, useState } from "react";
import { BaseUrl } from "../..";
const StudentHeader = ({ onFiltered }) => {
  const [filterData, setFilterData] = useState({
    name: "",
    phone: "",
    email: "",
    fromdate: "",
    todate: "",
  });

  const [showFilter, setShowFilter] = useState(false);
  const filterStudentApi = async () => {
    const token = localStorage.getItem("access_token");
    const formData = new FormData();
    formData.append("name", filterData.name);
    formData.append("phone", filterData.phone);
    formData.append("email", filterData.email);
    formData.append("from_date", filterData.fromdate);
    formData.append("to_date", filterData.todate);

    const response = await fetch(`${BaseUrl}filter-students`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },    
      body: formData,
    });

    const result = await response.json();
    if (onFiltered) onFiltered(result.result?.data);

    setShowFilter(false);
    setFilterData("")
  };

  const handleChange = (e) => {
    setFilterData({ ...filterData, [e.target.name]: e.target.value });
  };
  return (
    <>
      <div className="filter-dropdown position-relative">
        <div onClick={() => setShowFilter(!showFilter)}>
          <Link className="btn btn-md btn-light-brand">
            <i className="me-2">
              <FiFilter />
            </i>
            <span>Filter</span>
          </Link>
        </div>

        {showFilter && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.4)",
              backdropFilter: "blur(3px)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <div
              style={{
                width: "30%",
                maxWidth: "900px",
                background: "#fff",
                padding: "30px",
                borderRadius: "10px",
                maxHeight: "90vh",
                overflowY: "auto",
              }}
            >
              <h4 className="mb-4">Filter Students</h4>

              <input
                name="name"
                placeholder="Name"
                value={filterData.name}
                className="form-control mb-3"
                onChange={handleChange}
              />

              <input
                name="phone"
                placeholder="Phone"
                value={filterData.phone}
                className="form-control mb-3"
                onChange={handleChange}
              />

              <input
                name="email"
                placeholder="Email"
                value={filterData.email}
                className="form-control mb-3"
                onChange={handleChange}
              />

              <label>From Date</label>
              <input
                type="date"
                name="fromdate"
                value={filterData.fromdate}
                className="form-control mb-3"
                onChange={handleChange}
                max={filterData.todate ||""}
              />

              <label>To Date</label>
              <input
                type="date"
                name="todate"
                value={filterData.todate}
                className="form-control mb-4"
                onChange={handleChange}
                min={filterData.fromdate || ""}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <button
                  className="btn btn-primary w-50"
                  onClick={filterStudentApi}
                >
                  APPLY
                </button>

                <button  className="btn btn-primary w-50"
                  onClick={() => setShowFilter(false)}
                 
                >
                  CLOSE
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default StudentHeader;
